import React, { useEffect, useState, memo } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton,
  Button,
  Box,
  MenuItem,
  Select,
  Checkbox,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import style from "../../../../styles/gri/general.module.css";
import { getRowErrorMessages } from "../../../../utils/getRowErrorMessage";
import {
  validateNumber,
  validateNumberInput,
  validatePercentage,
} from "../../../../utils/validateFields";
import DeleteRowDialog from "../../../../Components/Common/DeleteRowDialog";

const DynamicTable = ({
  inputData,
  subHeading,
  tables,
  setTables,
  errors,
  setErrors,
  data,
  disabled,
  hide,
}) => {
  useEffect(() => {
    setTables(
      inputData?.map((section) => ({
        fieldName: section?.fieldName,
        rows:
          data?.[section?.fieldName]?.length > 0
            ? data[section?.fieldName]
            : [{}],
      }))
    );
  }, [data]);

  const [fieldToRemove, setFieldToRemove] = React.useState({
    tableIndex: null,
    rowIndex: null,
  });

  const [openDialog, setOpenDialog] = React.useState(false);
  const [isFilled, setIsFilled] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    const selected = tables
      .flatMap((table) => table.rows)
      .map((row) => row.categories)
      .filter(Boolean); // Removes undefined or empty values
    setSelectedCategories(selected);
  }, [tables]);

  const handleAddRow = (tableIndex) => {
    setTables((prev) => {
      const newTables = [...prev];
      newTables[tableIndex].rows.push({});
      return newTables;
    });
  };

  const handleRemoveRow = (tableIndex, rowIndex) => {
    setTables((prev) => {
      const newTables = [...prev];
      if (
        Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
      ) {
        setOpenDialog(true);
        setFieldToRemove({ tableIndex, rowIndex });
        return newTables;
      }

      newTables[tableIndex].rows.splice(rowIndex, 1);

      return newTables;
    });
  };

  const cancelRemoveRow = () => {
    setOpenDialog(false);
  };

  const confirmRemoveRow = () => {
    if (fieldToRemove) {
      const { tableIndex, rowIndex } = fieldToRemove;
      setTables((prev) => {
        const newTables = [...prev];
        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    }
    setOpenDialog(false);
  };

  const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
    console.log(value);
    if (type === "percentage" && !validatePercentage(value)) return;
    if (type === "number" && !validateNumberInput(value)) return;

    if (fieldName === "categories") {
      setSelectedCategories((prev) => [...new Set([...prev, value])]);
    }

    const updatedTables = [...tables];
    updatedTables[tableIndex].rows[rowIndex][fieldName] = value;

    const updatedErrors = { ...errors };
    if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
      delete updatedErrors[tableIndex][rowIndex][fieldName];
      if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
        delete updatedErrors[tableIndex][rowIndex];
      }
      if (Object.keys(updatedErrors[tableIndex]).length === 0) {
        delete updatedErrors[tableIndex];
      }
    }

    setErrors(updatedErrors);
    setTables(updatedTables);
    checkIfAdded();
  };

  useEffect(() => {
    checkIfAdded();
  }, [tables, inputData]); // Run only when tables or inputData change

  const checkIfAdded = () => {
    tables.forEach((table, tableIndex) => {
      const rows = table?.rows || [];
      const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; // Ensure lastRow is an object
      const filteredLastRow = Object.fromEntries(
        Object.entries(lastRow).filter(([key]) => key !== "_id")
      );

      const optionalLength = inputData?.[tableIndex]?.fields?.filter(
        (el) => el?.optional
      )?.length;
      console.log(optionalLength, "option");
      // Check if lastRow is fully filled
      const isComplete =
        Object.keys(filteredLastRow).length >=
          (inputData?.[tableIndex]?.fields?.length - optionalLength || 0) &&
        Object.values(filteredLastRow)?.every(
          (val) =>
            val !== undefined && val !== "" && val !== null && val?.length !== 0
        );
      console.log("complte", lastRow, isComplete);
      setIsFilled((prevState) => ({
        ...prevState,
        [tableIndex]: !isComplete, // true if incomplete, false if fully filled
      }));
    });
  };

  // const calculateTotal = (rows, fieldName) => {
  //     return rows.reduce((total, row) => {
  //       const value = parseFloat(row[fieldName]) || 0;
  //       return total + value;
  //     }, 0);
  //   };

  const calculateTotal = (rows = [], fieldName) => {
    if (!Array.isArray(rows)) return 0; // Ensure rows is always an array
    return rows.reduce((total, row) => {
      const value = parseFloat(row?.[fieldName]) || 0;
      return total + value;
    }, 0);
  };

  return (
    <Box>
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
      {subHeading && <p className={style.subHeading}>{subHeading}</p>}
      {inputData?.map((section, tableIndex) => (
        <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            {section?.letter && (
              <p className={style.ques_heading}>{section.letter}</p>
            )}
            <p className={style.ques_heading}>{section.title}</p>
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "10px",
              ml: 2,
              width: "98%",
            }}
          >
            <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
              <TableHead>
                <TableRow
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#1C486B",
                    border: "1px solid #ddd",
                  }}
                >
                  <TableCell
                    sx={{
                      border: "1px solid #ddd",
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      width: "1rem",
                      textAlign: "center",
                    }}
                  >
                    S. No.
                  </TableCell>
                  {section?.fields?.map((field) => (
                    <TableCell
                      key={field?.fieldName}
                      style={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: field.width,
                        maxWidth: field.width,
                      }}
                    >
                      {field?.title}
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      width: "1rem",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                  console.log(row, "checking row");
                  return (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        "& > th": {
                          color: "white",
                          fontWeight: "bold",
                          py: "0.5rem",
                          px: "0.5rem",
                          border: "1px solid rgba(224, 224, 224, 1)",
                          height: "30px",
                        },
                      }}
                    >
                      <TableCell sx={{ textAlign: "center", width: "8%" }}>
                        {rowIndex + 1} .
                      </TableCell>
                      {section?.fields?.map((field) => (
                        <TableCell
                          key={field?.fieldName}
                          sx={{ border: "1px solid #DBDBDB", py: "0.5rem" }}
                        >
                          {field.type === "select" ? (
                            <Select
                              value={row.categories || ""}
                              disabled={disabled}
                              onChange={(e) =>
                                handleInputChange(
                                  tableIndex,
                                  rowIndex,
                                  "categories",
                                  e.target.value
                                )
                              }
                              fullWidth
                              displayEmpty
                              size="small"
                              sx={{
                                border: "none",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none",
                                  },
                              }}
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>
                              {section?.fields
                                ?.find(
                                  (field) => field.fieldName === "categories"
                                )
                                ?.options.map((option) => (
                                  <MenuItem
                                    key={option}
                                    value={option}
                                    disabled={
                                      selectedCategories.includes(option) &&
                                      row.categories !== option
                                    }
                                  >
                                    {option}
                                  </MenuItem>
                                ))}
                            </Select>
                          ) : field.type === "radio" ? (
                            // console.log(row,row[field.fieldName],"Checking...")
                            <Box sx={{ display: "flex" }}>
                              <FormControl sx={{ my: 1, display: "flex" }}>
                                <RadioGroup
                                  row
                                  value={row[field.fieldName] || "Yes"}
                                  onChange={(e) =>
                                    handleInputChange(
                                      tableIndex,
                                      rowIndex,
                                      field.fieldName,
                                      e.target.value,
                                      field.type
                                    )
                                  }
                                  disabled={disabled}
                                >
                                  <FormControlLabel
                                    value="Yes"
                                    control={<Radio disabled={disabled} />}
                                    label="Yes"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio disabled={disabled} />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Box>
                          ) : (
                            <TextField
                              placeholder={field.placeholder}
                              type={field.type}
                              value={row[field.fieldName] || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  tableIndex,
                                  rowIndex,
                                  field.fieldName,
                                  e.target.value,
                                  field.type
                                )
                              }
                              multiline
                              disabled={disabled}
                              // rows={1}
                              sx={{
                                width: "100%",
                                py: "0.5rem",
                                "& .MuiInputBase-root": {
                                  overflowY: "auto",
                                  cursor: "default", // default cursor
                                },
                                "& .MuiInputBase-root:hover": {
                                  cursor: "pointer", // pointer cursor on hover
                                },
                              }}
                              size="small"
                              variant="standard"
                              InputProps={{ disableUnderline: true }}
                            />
                          )}
                        </TableCell>
                      ))}

                      <TableCell sx={{ width: "8%" }}>
                        <IconButton
                          disabled={
                            tables[tableIndex]?.rows?.length === 1 || disabled
                          }
                          onClick={() => handleRemoveRow(tableIndex, rowIndex)}
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}

                <TableRow sx={{ backgroundColor: "#DBDBDB" }}>
                  <TableCell
                    sx={{ borderRight: "1px solid #D8D8D8" }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #D8D8D8",
                      fontWeight: 600,
                      color: "#222222",
                    }}
                  >
                    Total Hours
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #D8D8D8",
                      fontWeight: 600,
                      color: "#222222",
                    }}
                  >
                    {calculateTotal(tables[tableIndex]?.rows, "male")}
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #D8D8D8",
                      fontWeight: 600,
                      color: "#222222",
                    }}
                  >
                    {calculateTotal(tables[tableIndex]?.rows, "female")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 1, ml: 3 }}>
            {Object.keys(errors).length > 0 &&
              getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                (errorMessage, idx) => (
                  <p
                    key={idx}
                    color="error"
                    variant="caption"
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                    }}
                  >
                    {errorMessage}
                  </p>
                )
              )}
          </Box>
          {/* Add row button */}
          {!hide && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                endIcon={<Add />}
                disabled={isFilled?.[tableIndex] || disabled}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  // marginTop: "1rem",
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
          )}

          {/* Dynamic error messages for missing fields */}
        </div>
      ))}
    </Box>
  );
};

const DynamicTable1 = ({
  inputData,
  subHeading,
  tables,
  setTables,
  errors,
  setErrors,
  data,
  disabled,
  hide,
}) => {
  useEffect(() => {
    setTables(
      inputData?.map((section) => ({
        fieldName: section?.fieldName,
        rows:
          data?.[section?.fieldName]?.length > 0
            ? data[section?.fieldName]
            : [{}],
      }))
    );
  }, [data]);

  const [fieldToRemove, setFieldToRemove] = React.useState({
    tableIndex: null,
    rowIndex: null,
  });

  const [openDialog, setOpenDialog] = React.useState(false);
  const [isFilled, setIsFilled] = useState({});
  const [selectedCategories, setSelectedCategories] = useState([]);

  useEffect(() => {
    const selected = tables
      .flatMap((table) => table.rows)
      .map((row) => row.ageGroup)
      .filter(Boolean); // Removes undefined or empty values
    setSelectedCategories(selected);
  }, [tables]);

  const handleAddRow = (tableIndex) => {
    setTables((prev) => {
      const newTables = [...prev];
      newTables[tableIndex].rows.push({});
      return newTables;
    });
  };

  const handleRemoveRow = (tableIndex, rowIndex) => {
    setTables((prev) => {
      const newTables = [...prev];
      if (
        Object.values(newTables[tableIndex].rows[rowIndex]).some((val) => val)
      ) {
        setOpenDialog(true);
        setFieldToRemove({ tableIndex, rowIndex });
        return newTables;
      }

      newTables[tableIndex].rows.splice(rowIndex, 1);

      return newTables;
    });
  };

  const cancelRemoveRow = () => {
    setOpenDialog(false);
  };

  const confirmRemoveRow = () => {
    if (fieldToRemove) {
      const { tableIndex, rowIndex } = fieldToRemove;
      setTables((prev) => {
        const newTables = [...prev];
        newTables[tableIndex].rows.splice(rowIndex, 1);
        return newTables;
      });
    }
    setOpenDialog(false);
  };

  const handleInputChange = (tableIndex, rowIndex, fieldName, value, type) => {
    console.log(value);
    if (type === "percentage" && !validatePercentage(value)) return;
    if (type === "number" && !validateNumberInput(value)) return;

    if (fieldName === "ageGroup") {
      setSelectedCategories((prev) => [...new Set([...prev, value])]);
    }

    const updatedTables = [...tables];
    updatedTables[tableIndex].rows[rowIndex][fieldName] = value;

    const updatedErrors = { ...errors };
    if (updatedErrors[tableIndex] && updatedErrors[tableIndex][rowIndex]) {
      delete updatedErrors[tableIndex][rowIndex][fieldName];
      if (Object.keys(updatedErrors[tableIndex][rowIndex]).length === 0) {
        delete updatedErrors[tableIndex][rowIndex];
      }
      if (Object.keys(updatedErrors[tableIndex]).length === 0) {
        delete updatedErrors[tableIndex];
      }
    }

    setErrors(updatedErrors);
    setTables(updatedTables);
    checkIfAdded();
  };

  useEffect(() => {
    checkIfAdded();
  }, [tables, inputData]); // Run only when tables or inputData change

  const checkIfAdded = () => {
    tables.forEach((table, tableIndex) => {
      const rows = table?.rows || [];
      const lastRow = rows.length > 0 ? rows[rows.length - 1] : {}; // Ensure lastRow is an object
      const filteredLastRow = Object.fromEntries(
        Object.entries(lastRow).filter(([key]) => key !== "_id")
      );

      const optionalLength = inputData?.[tableIndex]?.fields?.filter(
        (el) => el?.optional
      )?.length;
      console.log(optionalLength, "option");
      // Check if lastRow is fully filled
      const isComplete =
        Object.keys(filteredLastRow).length >=
          (inputData?.[tableIndex]?.fields?.length - optionalLength || 0) &&
        Object.values(filteredLastRow)?.every(
          (val) =>
            val !== undefined && val !== "" && val !== null && val?.length !== 0
        );
      console.log("complte", lastRow, isComplete);
      setIsFilled((prevState) => ({
        ...prevState,
        [tableIndex]: !isComplete, // true if incomplete, false if fully filled
      }));
    });
  };

  const calculateTotal = (rows = [], fieldName) => {
    if (!Array.isArray(rows)) return 0; // Ensure rows is always an array
    return rows.reduce((total, row) => {
      const value = parseFloat(row?.[fieldName]) || 0;
      return total + value;
    }, 0);
  };

  return (
    <Box>
      <DeleteRowDialog {...{ openDialog, cancelRemoveRow, confirmRemoveRow }} />
      {/* {Heading && <p className={style.Heading}>{Heading}</p>} */}
      {subHeading && <p className={style.subHeading}>{subHeading}</p>}
      {inputData?.map((section, tableIndex) => (
        <div key={section.fieldName} sx={{ marginBottom: "1rem" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            {section?.letter && (
              <p className={style.ques_heading}>{section.letter}</p>
            )}
            <p className={style.ques_heading}>{section.title}</p>
          </Box>

          <TableContainer
            component={Paper}
            sx={{
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              borderRadius: "10px",
              ml: 2,
              width: "98%",
            }}
          >
            <Table sx={{ border: "1px solid #ddd", borderRadius: "10px" }}>
              <TableHead>
                <TableRow
                  sx={{
                    borderRadius: "10px",
                    backgroundColor: "#1C486B",
                    border: "1px solid #ddd",
                  }}
                >
                  <TableCell
                    sx={{
                      border: "1px solid #ddd",
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      width: "1rem",
                      textAlign: "center",
                    }}
                  >
                    S. No.
                  </TableCell>
                  {section?.fields?.map((field) => (
                    <TableCell
                      key={field?.fieldName}
                      style={{
                        border: "1px solid #ddd",
                        fontWeight: "bold",
                        color: "#FFFFFF",
                        width: field.width,
                      }}
                    >
                      {field?.title}
                    </TableCell>
                  ))}
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      color: "#FFFFFF",
                      width: "1rem",
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tables[tableIndex]?.rows?.map((row, rowIndex) => {
                  console.log(row, "checking row");
                  return (
                    <TableRow
                      key={rowIndex}
                      sx={{
                        "& > th": {
                          color: "white",
                          fontWeight: "bold",
                          py: "0.5rem",
                          px: "0.5rem",
                          border: "1px solid rgba(224, 224, 224, 1)",
                          height: "30px",
                        },
                      }}
                    >
                      <TableCell sx={{ textAlign: "center", width: "8%" }}>
                        {rowIndex + 1} .
                      </TableCell>
                      {section?.fields?.map((field) => (
                        <TableCell
                          key={field?.fieldName}
                          sx={{ border: "1px solid #DBDBDB", py: "0.5rem" }}
                        >
                          {field.type === "select" ? (
                            <Select
                              value={row.ageGroup || ""}
                              onChange={(e) =>
                                handleInputChange(
                                  tableIndex,
                                  rowIndex,
                                  "ageGroup",
                                  e.target.value
                                )
                              }
                              fullWidth
                              displayEmpty
                              size="small"
                              disabled={disabled}
                              sx={{
                                border: "none",
                                "& .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                  border: "none",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                  {
                                    border: "none",
                                  },
                              }}
                            >
                              <MenuItem value="" disabled>
                                Select
                              </MenuItem>
                              {section?.fields
                                ?.find(
                                  (field) => field.fieldName === "ageGroup"
                                )
                                ?.options.map((option) => (
                                  <MenuItem
                                    key={option}
                                    value={option}
                                    disabled={
                                      selectedCategories.includes(option) &&
                                      row.ageGroup !== option
                                    }
                                  >
                                    {option}
                                  </MenuItem>
                                ))}
                            </Select>
                          ) : field.type === "radio" ? (
                            // console.log(row,row[field.fieldName],"Checking...")
                            <Box sx={{ display: "flex" }}>
                              <FormControl sx={{ my: 1, display: "flex" }}>
                                <RadioGroup
                                  row
                                  value={row[field.fieldName] || "Yes"}
                                  onChange={(e) =>
                                    handleInputChange(
                                      tableIndex,
                                      rowIndex,
                                      field.fieldName,
                                      e.target.value,
                                      field.type
                                    )
                                  }
                                  disabled={disabled}
                                >
                                  <FormControlLabel
                                    value="Yes"
                                    control={<Radio disabled={disabled} />}
                                    label="Yes"
                                  />
                                  <FormControlLabel
                                    value="No"
                                    control={<Radio disabled={disabled} />}
                                    label="No"
                                  />
                                </RadioGroup>
                              </FormControl>
                            </Box>
                          ) : (
                            <TextField
                              placeholder={field.placeholder}
                              type={field.type}
                              value={row[field.fieldName] || ""}
                              disabled={disabled}
                              onChange={(e) =>
                                handleInputChange(
                                  tableIndex,
                                  rowIndex,
                                  field.fieldName,
                                  e.target.value,
                                  field.type
                                )
                              }
                              multiline
                              // rows={1}
                              sx={{
                                width: "100%",
                                py: "0.5rem",
                                "& .MuiInputBase-root": {
                                  overflowY: "auto",
                                  cursor: "default", // default cursor
                                },
                                "& .MuiInputBase-root:hover": {
                                  cursor: "pointer", // pointer cursor on hover
                                },
                              }}
                              size="small"
                              variant="standard"
                              InputProps={{ disableUnderline: true }}
                            />
                          )}
                        </TableCell>
                      ))}

                      <TableCell sx={{ width: "8%" }}>
                        <IconButton
                          disabled={
                            tables[tableIndex]?.rows?.length === 1 || disabled
                          }
                          onClick={() => handleRemoveRow(tableIndex, rowIndex)}
                          color="error"
                        >
                          <Delete />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })}

                <TableRow sx={{ backgroundColor: "#DBDBDB" }}>
                  <TableCell
                    sx={{ borderRight: "1px solid #D8D8D8" }}
                  ></TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #D8D8D8",
                      fontWeight: 600,
                      color: "#222222",
                    }}
                  >
                    Total Hours
                  </TableCell>
                  <TableCell
                    sx={{
                      borderRight: "1px solid #D8D8D8",
                      fontWeight: 600,
                      color: "#222222",
                    }}
                  >
                    {calculateTotal(tables[tableIndex]?.rows, "hours")}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <Box sx={{ mt: 1, ml: 3 }}>
            {Object.keys(errors).length > 0 &&
              getRowErrorMessages(tableIndex, inputData, tables, errors).map(
                (errorMessage, idx) => (
                  <p
                    key={idx}
                    color="error"
                    variant="caption"
                    style={{
                      lineHeight: "1.2",
                      margin: "2px 0",
                      color: "#d34040",
                      fontSize: "10px",
                      fontStyle: "italic",
                    }}
                  >
                    {errorMessage}
                  </p>
                )
              )}
          </Box>
          {/* Add row button */}
          {!hide && (
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                endIcon={<Add />}
                disabled={isFilled?.[tableIndex] || disabled}
                onClick={() => handleAddRow(tableIndex)}
                sx={{
                  // marginTop: "1rem",
                  color: "#1C486B",
                  width: "7rem",
                  borderColor: "#1C486B",
                }}
                variant="outlined"
              >
                Add
              </Button>
            </Box>
          )}

          {/* Dynamic error messages for missing fields */}
        </div>
      ))}
    </Box>
  );
};

// export default DynamicTable;
export { DynamicTable, DynamicTable1 };
